import React from 'react';
import { DollarSign, ChevronDown, Info } from 'lucide-react';

const DepositSelectionSection = ({
  reservationSettings,
  reservationData,
  handleEnhancedInputChange,
  fieldValidation,
  isSaving,
  uploadingDocuments
}) => {
  
  // Get default deposit if not already set
  const getDefaultDeposit = () => {
    const defaultDeposit = reservationSettings.depositOptions?.find(d => d.isDefault);
    return defaultDeposit?.label || reservationSettings.depositOptions?.[0]?.label || '$100';
  };

  // Get currency info for selected deposit
  const getSelectedDepositInfo = () => {
    const selectedLabel = reservationData.depositAmount || getDefaultDeposit();
    const deposit = reservationSettings.depositOptions?.find(d => d.label === selectedLabel);
    return deposit;
  };

  const selectedDepositInfo = getSelectedDepositInfo();

  return (
    <div>
      <div className="flex items-center gap-2 mb-3">
        <div className="w-8 h-8 rounded-lg bg-gradient-to-r from-green-500 to-emerald-600 flex items-center justify-center flex-shrink-0">
          <DollarSign size={16} className="text-white" />
        </div>
        <div className="min-w-0">
          <h3 className="text-white font-medium text-sm sm:text-base">Security Deposit</h3>
        </div>
      </div>

      <div className="bg-gray-700/30 border border-gray-600 rounded-lg p-3 sm:p-4 space-y-4">
        
        {/* Deposit Selection */}
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Select Deposit Amount <span className="text-red-400">*</span>
          </label>
          
          {reservationSettings.depositOptions?.length > 1 ? (
            // Multiple options - Show dropdown
            <div className="relative">
              <DollarSign className="absolute left-3 top-3 w-4 h-4 text-gray-400 pointer-events-none z-10" />
              <select
                name="depositAmount"
                value={reservationData.depositAmount || getDefaultDeposit()}
                onChange={(e) => handleEnhancedInputChange(e)}
                disabled={isSaving || uploadingDocuments}
                className="w-full pl-9 pr-10 py-2.5 bg-gray-700 border border-gray-600 text-white rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent appearance-none cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed text-sm"
              >
                {reservationSettings.depositOptions.map(deposit => (
                  <option key={deposit.id} value={deposit.label}>
                    {deposit.label} {deposit.isDefault ? '(Recommended)' : ''} - {deposit.currency}
                  </option>
                ))}
              </select>
              <ChevronDown className="absolute right-3 top-3 w-4 h-4 text-gray-400 pointer-events-none" />
            </div>
          ) : (
            // Single option - Show as static display
            <div className="bg-gray-700/50 border border-gray-600 rounded-lg p-3 flex items-center justify-between">
              <div className="flex items-center gap-2">
                <DollarSign className="w-5 h-5 text-gray-400 flex-shrink-0" />
                <div>
                  <span className="font-medium text-white text-lg">
                    {reservationData.depositAmount || getDefaultDeposit()}
                  </span>
                  <span className="text-sm text-gray-400 ml-2">(Standard deposit)</span>
                </div>
              </div>
              {selectedDepositInfo && (
                <div className="text-xs text-gray-400">
                  {selectedDepositInfo.currency}
                </div>
              )}
            </div>
          )}


        </div>

        {/* Validation Error */}
        {fieldValidation?.depositAmount && !fieldValidation.depositAmount.isValid && (
          <div className="bg-red-900/30 border border-red-700 rounded-lg p-2">
            <p className="text-red-300 text-xs flex items-center">
              {fieldValidation.depositAmount.errors?.[0] || 'Please select a deposit amount'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default DepositSelectionSection;